import gql from 'graphql-tag';

export const GENERATE_DOCTOR_SMARTLINK = gql`
  query generateDoctorSmartlink {
    generateDoctorSmartlink {
      shortId
    }
  }
`;

export const GENERATE_CLINIC_SMARTLINK = gql`
  query generateClinicSmartlink {
    generateClinicSmartlink {
      shortId
    }
  }
`;

export const GET_CLINIC_BY_SMARTLINK = gql`
  query getClinicBySmartlink($token: String) {
    getClinicBySmartlink(token: $token) {
      clinic {
        id
        name
        isAvailableAddPatient
      }
      isUnavailable
    }
  }
`;

export const GET_DOCTOR_BY_SMARTLINK = gql`
  query getDoctorBySmartlink($token: String) {
    getDoctorBySmartlink(token: $token) {
      doctor {
        id
        firstName
        lastName
        isActive
        isAvailableAddPatient
      }
      isUnavailable
    }
  }
`;

export function getSmartlinkTokenDoctor() {
  const location = window.location;
  const query = new URLSearchParams(location.search);
  return query.get('d');
}

export function getSmartlinkTokenClinic() {
  const location = window.location;
  const query = new URLSearchParams(location.search);
  return query.get('c');
}
